import { createAxios } from "./axiosHttpMarconi";

export const whatsappTemplateService = {
  getWhatsappTemplates,
  deleteWhatsappTemplate,
  postWhatsappTemplate,
  updateWhatsappTemplate,
  getWhatsappTemplateById,
  getMetaWhatsappTemplates,
};

function getWhatsappTemplates(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/whatsapp-templates`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0";
  }
  if (filters && filters.nombre) {
    urlPath += `&nombre=${filters.nombre}`;
  }
  if (
    filters &&
    filters.permiteRespuesta !== undefined &&
    filters.permiteRespuesta !== ""
  ) {
    urlPath += `&permiteRespuesta=${filters.permiteRespuesta}`;
  }
  return axios.get(urlPath);
}

function deleteWhatsappTemplate(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/whatsapp-templates/${id}`;
  return axios.delete(urlPath);
}

function postWhatsappTemplate(request) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/whatsapp-templates`;
  return axios.post(urlPath, request);
}

function updateWhatsappTemplate(id, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/whatsapp-templates/${id}`;
  return axios.put(urlPath, body);
}

function getWhatsappTemplateById(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/whatsapp-templates/${id}`;
  return axios.get(urlPath);
}

function getMetaWhatsappTemplates() {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  const urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/whatsapp-templates/meta`;
  return axios.get(urlPath);
}
